import filterConstants from '../constants';

const timeloglist = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.timeloglist,
  properties: {
    [filterConstants.PROPERTY.task_name]: '',
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.resource_id]: '',
    [filterConstants.PROPERTY.date]: '',
    [filterConstants.PROPERTY.time]: '',
    [filterConstants.PROPERTY.comment]: '',
  },
});

export default timeloglist;
